module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/ko/1-63e2042dc3ac92c601e9bc772e5b80ce.jpg";